import GenericShelfv2 from './GenericShelfV2'

export default GenericShelfv2
